import { IReactionDisposer } from "mobx";

export class MobxReactionDisposer {
    private disposers: IReactionDisposer[] | undefined;
    
    public add(reaction: IReactionDisposer): void;
    public add(reactions: IReactionDisposer[]): void;
    public add(value: IReactionDisposer | IReactionDisposer[])
    {
        this.disposers = this.disposers ?? [];

        if (value instanceof Array)
            this.disposers.push(...value);
        else
            this.disposers.push(value);
    }

    public clear() {        
        this.disposers?.forEach(d => d());
        this.disposers = undefined;
    }
}